import i18n from 'i18next';

/**
 * The observability skeleton's own namespace (SL-1947). The skeleton is in the
 * initial bundle (RouteSkeleton, the agent layout, the router), so it must not
 * import the `agent-observability` namespace — the module's whole copy, which
 * every user would download before any screen. It carries only what the
 * skeleton says: its label. `__tests__/ObservabilitySkeleton.test.tsx` keeps the
 * three languages in step.
 */
export const NS = 'observability-skeleton';

export const en = { loading: "Loading the agent's log" };
export const es: typeof en = { loading: 'Cargando la bitácora del agente' };
export const pt: typeof en = { loading: 'Carregando o registro do agente' };

// Guarded so importing this module is safe where the i18next singleton isn't
// initialized (the jest runner); in the app it is, before the first render.
if (typeof i18n.addResourceBundle === 'function') {
  i18n.addResourceBundle('en', NS, en, true, true);
  i18n.addResourceBundle('es', NS, es, true, true);
  i18n.addResourceBundle('pt', NS, pt, true, true);
}
